import React from "react";

// Article text in the small markdown subset the backend uses (Word import / typed by the admin, see
// backend/lib/editionPdf.js textBlocks): "# / ## / ###" heading lines, "- " list lines, **bold** inside a line,
// a blank line between paragraphs. Shown as real headings / lists / bold — never as raw "#" or "**".
function inline(text) {
  return String(text)
    .split(/(\*\*[^*]+\*\*)/)
    .filter(Boolean)
    .map((part, i) => (/^\*\*[^*]+\*\*$/.test(part) ? <strong key={i}>{part.slice(2, -2)}</strong> : part));
}

export function plainText(text) {
  return String(text || "").replace(/\*\*([^*]+)\*\*/g, "$1").replace(/^\s*#{1,3}\s+/gm, "");
}

function RichText({ text }) {
  const lines = String(text || "")
    .replace(/\r\n/g, "\n")
    .split(/\n{2,}/)
    .flatMap((para) => para.split("\n"))
    .map((line) => line.trimEnd())
    .filter((line) => line.trim() !== "");

  const out = [];
  let list = null;
  lines.forEach((line, i) => {
    const li = line.match(/^\s*[-*•]\s+(.*)$/);
    if (li) {
      if (!list) {
        list = [];
        out.push(<ul key={`ul-${i}`}>{list}</ul>);
      }
      list.push(<li key={i}>{inline(li[1])}</li>);
      return;
    }
    list = null;
    const h = line.match(/^\s*(#{1,3})\s+(.*)$/);
    if (h) {
      const Tag = `h${h[1].length + 2}`; // # → h3, ## → h4, ### → h5 (the page title is h1/h2)
      out.push(<Tag key={i} className="rich-heading">{plainText(h[2])}</Tag>);
      return;
    }
    out.push(<p key={i}>{inline(line.trim())}</p>);
  });
  return <>{out}</>;
}

export default RichText;
